import { Button, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import { useNavigate } from "react-router-dom";
import {
  filterConstants,
  permissionsConstants,
} from "../../constants/AppConstants";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";

interface updateShopUser {
  closeDrawer?: Function;
  openUpdate?: Function;
  shopUser?: any;
}

const UpdateShopUser = (props: updateShopUser) => {
  const { getUserPermission:getShopUserPermissions} = usePermissionGetter(
    permissionsConstants.admin,
    permissionsConstants.shop_user
  );
  const status = filterConstants.Active;
  const { closeDrawer, shopUser, openUpdate } = props;
  const buttonStyles = useButtonStyles();
  const navigate = useNavigate();

  const NavigateToAdmin = () => {
    navigate("/admin");
    closeDrawer && closeDrawer(false);
  };

  return (
    <Grid height={"100%"}>
      <Grid
        height={"15%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={3}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
          pl={2}
        >
          {shopUser?.name ? shopUser?.name : ""}
        </Typography>
        <IconButton
          aria-label="delete"
          onClick={closeDrawer ? () => NavigateToAdmin() : () => {}}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid height={"85%"} px={3}>
        <Grid
          border={theme.border?.newGreyBorder}
          sx={{ background: theme.color?.newGreyBackground }}
          borderRadius={"16px"}
          height={"45%"}
          px={3}
          py={2}
        >
          <Grid height={"25%"} display={"flex"} gap={1}>
            <Grid width={"30%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                First Name
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {shopUser?.firstName || ""}
              </Typography>
            </Grid>
            <Grid width={"30%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Last Name
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {shopUser?.lastName || ""}
              </Typography>
            </Grid>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Email
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {shopUser?.email || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid height={"25%"} display={"flex"} gap={1}>
            <Grid width={"30%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Mobile No
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {shopUser?.mobileNumber || ""}
              </Typography>
            </Grid>
            <Grid width={"30%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Merchant
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {shopUser?.merchant || ""}
              </Typography>
            </Grid>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Role
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {shopUser?.role || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid height={"25%"} display={"flex"} gap={1}>
            <Grid width={"29%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Designation
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {shopUser?.designation || ""}
              </Typography>
            </Grid>
            <Grid
              width={"29%"}
              display={"flex"}
              flexDirection={"column"}
              gap={1}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Status
              </Typography>
              <Typography
                fontSize={theme.font?.fontSize.tableBody}
                sx={{
                  textAlign: "center",
                  color:
                    shopUser?.status === filterConstants.Active
                      ? theme?.color?.success
                      : theme?.color?.error,
                  backgroundColor:
                    shopUser?.status === filterConstants.Active
                      ? theme?.color?.successLight
                      : theme.color?.errorLight,
                  borderRadius: "13px",
                  fontFamily: theme.font?.fontFamily.primary,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                minWidth={"40%"}
                maxWidth={"40%"}
              >
                {shopUser?.status || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid>
            {getShopUserPermissions("update") && (
              <CommonButton
                buttonTitle="Update Profile"
                color="secondary"
                onClick={openUpdate ? () => openUpdate() : () => {}}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UpdateShopUser;
